'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var DeviceSelection = require('utils/device_selection');
var FilterSelectWizardView = require('components/devices/views/common/filter_select_wizard_view');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var Decorator = require('utils/decoration');
var Alarm = require('utils/alarm');

var ValueType = {
    Text: 0,
    Enum: 1,
    Status: 2,
};

var knownFormats = {
    '': true,
    '/10': true,
    '/100': true,
    '/1000': true,
    '/10000': true,
    '/1000f3': true,
    '/100f2': true,
    '/10f1': true,
    '/10f2': true,
    f1: true,
    f2: true,
};

function canShowRawValue(format) {
    return !knownFormats[format || ''];
}

function createDlgAlarm(m) {
    var result = new Backbone.Model(Misc.cloneAsJSON(m.toJSON()));
    result.set(
        'send_list',
        _.map(m.get('send_list'), function (item) {
            return item.id;
        })
    );
    if (!result.id) {
        result.set('conditions', [
            {
                line1: Consts.AlarmStatusField,
                comparison: 'ANY',
                selected: true,
                line1key: Alarm.getDeviceValueKey({
                    id: Consts.AlarmStatusField,
                    name: Consts.AlarmStatusFieldText,
                    unit: '',
                }),
            },
        ]);
    }

    var conditions = result.get('conditions');
    Alarm.updateConditionsKey(conditions);

    return result;
}

function isNumeric(value) {
    return value !== '' && value !== undefined && value !== null && !isNaN(Number(value));
}

var AlarmDialogView = OOP.extend(
    FilterSelectWizardView,
    {
        template: require('components/devices/templates/alarm/alarm_dialog'),

        filterTab: 1,
        selectTab: 2,
        constraintTab: 3,
        alarmTab: 4,

        ui: OOP.inheritedObj('ui', {
            categoryError: '#js-category-alert',
            selectValue: '#alarm-value',
            selectUnit: '#alarm-unit',
            alarmName: '#alarm-name',
            priority: '#alarm-priority',
            sendToMailList: '#js-receiver-other',
            sendToMe: '#js-receiver-me',
        }),

        templateHelpers: {
            alarmDelays: [],
            units: [
                { value: 1, display: I18N.TR('Minuten') },
                { value: 60, display: I18N.TR('Stunden') },
                { value: 1440, display: I18N.TR('Tagen') },
            ],
        },

        events: OOP.inheritedObj('events', {
            'click button.js-delete': function (e) {
                this.deleteCond(e);
            },
            'change select.js-value-select': function (e) {
                this.saveCondValue(e);
            },
            'change select.js-value-status': function (e) {
                this.saveCondValue(e);
            },
            'change select.js-alarm-cond': function (e) {
                var self = this;
                this.saveCondition(e);
                this.render();
            },
            'change input.js-value': function (e) {
                var self = this;
                this.saveCondition(e);
                this.render();
            },
            'change select.js-alarm-attr': function (e) {
                this.saveAlarmDataItem(e, true);
            },
            'change input.js-alarm-attr': function (e) {
                this.saveAlarmDataItem(e, false);
            },
            'keyup input.js-alarm-attr': function (e) {
                this.saveAlarmDataItem(e, false);
            },
            'keyup .js-value': function (e) {
                this.saveCondValue(e);
            },
            'click #alarm-cond-add': function (e) {
                var rows = this.model.get('conditions');

                // unselect all
                _.each(rows, function (row) {
                    row.selected = false;
                });

                // create new one
                rows.push({
                    line1: Consts.AlarmStatusField,
                    comparison: 'ANY',
                    value: 0,
                    selected: true,
                    line1key: Alarm.getDeviceValueKey({
                        id: Consts.AlarmStatusField,
                        name: Consts.AlarmStatusFieldText,
                        unit: '',
                    }),
                });
                this.render();
            },
            'click input.js-alarm-receiver': function (e) {
                var isMe = e.currentTarget.id === 'js-receiver-me';
                Misc.setDisabled('#send_email', !isMe);
                Misc.setDisabled('#send_sms', !(isMe && AppState.user.get('phone')));
                Misc.setDisabled('#js-mailing-list, .js-receiver-other', isMe);
                document.getElementById('send_email').checked = false;
                document.getElementById('send_sms').checked = false;
                this.model.set('send_email', $('#send_email')[0].checked || !isMe);
            },
        }),

        alarmData: {},

        initialize: function (options) {
            this.base.initialize(options);
            var self = this;
            this.model = createDlgAlarm(options.model);
            var filter = Misc.cloneAsJSON(this.model.get('filter') || {});
            this.filterIntf = this.installFilter({
                filter: filter,
                selection: filter.selection,
            });

            var time = this.model.get('trigger_time') || 0;
            _.each([1, 60, 1440], function (unitValue) {
                if (time >= unitValue || unitValue == 1) {
                    self.model.set('trigger_time_unit', unitValue);
                    self.model.set('trigger_time_value', time / unitValue);
                }
            });

            for (var i = 1; i < 60; i++) {
                this.templateHelpers.alarmDelays.push({ value: i, display: i });
            }
        },

        saveAlarmDataItem: function (e, doRender) {
            var element = e.currentTarget;
            var name = element.name;
            var value = undefined;
            switch (element.tagName) {
                case 'SELECT':
                    var fct = element.multiple
                        ? function (x) {
                              return _.map(x, function (item) {
                                  return parseInt(item);
                              });
                          }
                        : parseInt;
                    value = fct($(element).val());
                    doRender = doRender && !element.multiple;
                    break;
                case 'INPUT':
                    switch (element.type) {
                        case 'checkbox':
                            value = element.checked;
                            break;
                        case 'radio':
                            var value = this.ui.sendToMe.prop('checked');
                            if (value) {
                                this.model.set('send_list', []);
                            }
                            value = $(element).val();
                            break;
                        default:
                            value = $(element).val();
                            break;
                    }
                    break;
            }
            this.model.set(name, value);
            if (doRender) {
                this.render();
            }
            this.updateWizardButtons();
        },

        updateWizardButtons: function () {
            this.base.updateWizardButtons();
            if (this.ui.categoryError) this.ui.categoryError.addClass('hidden');
        },

        deleteCond: function (e) {
            var ctx = this.getSelectedCondCtx(e);
            var conditions = this.model.get('conditions');
            conditions.splice(ctx.idx, 1);

            // select first one
            _.each(conditions, function (row, idx) {
                row.selected = idx == 0;
            });

            this.render();
        },

        getSelectedCondCtx: function (e) {
            var panel = $(e.currentTarget).closest('.js-analog-row');
            var idx = $(panel).attr('data-index');
            var conditions = this.model.get('conditions');
            var row = conditions[idx];

            _.each(conditions, function (cond, i) {
                cond.selected = i == idx;
            });

            return {
                panel: panel,
                idx: idx,
                row: row,
            };
        },

        saveCondValue: function (e) {
            var ctx = this.getSelectedCondCtx(e);
            var valueType = this.getCondValueType(ctx.row);

            switch (valueType) {
                case ValueType.Text:
                    var valueStr = $(ctx.panel).find('.js-value').val();
                    if (!isNumeric(valueStr)) return;

                    if (ctx.row.op == 'Z') {
                        ctx.row.value = parseFloat(valueStr);
                    } else {
                        ctx.row.value = Misc.getRawValue(
                            parseFloat(valueStr),
                            ctx.row.lineData.type,
                            ctx.row.lineData.format
                        );
                    }
                    break;
                case ValueType.Status:
                    ctx.row.value = Alarm.encodeStatus($(ctx.panel).find('select.js-value-status').val());
                    break;
                case ValueType.Enum:
                    ctx.row.value = parseInt($(ctx.panel).find('select.js-value-select').val());
                    break;
            }
        },

        saveCondition: function (e) {
            var ctx = this.getSelectedCondCtx(e);
            var row = ctx.row;
            var panel = ctx.panel;
            var oldUnit = row.lineData ? row.lineData.unit : undefined;
            var oldLine1 = row.line1;
            var oldType = row.valueType;
            row.line1key = $(panel).find('select.js-line-1').val();
            row.line2key = $(panel).find('select.js-line-2').val();

            row.line1 = Alarm.getIDFromKey(row.line1key);
            row.line2 = Alarm.getIDFromKey(row.line2key);

            row.comparison = $(panel).find('select.js-comparison').val();
            row.op = $(panel).find('select.js-op').val();
            row.valueType = this.getCondValueType(row);

            if (row.line1 == Consts.AlarmStatusField) {
                row.line2 = '';
                row.op = '';
            }

            if (row.op && !row.line2) {
                row.line2 = row.line1;
            }

            var line2 = AppState.availableColumnDataByKey(row.line2key, this.getAlarmCategories());
            row.lineData = AppState.availableColumnDataByKey(row.line1key, this.getAlarmCategories());

            if (line2 && line2.unit !== row.lineData.unit) {
                row.line2 = row.line1;
            }

            var newUnit = ctx.row.lineData ? ctx.row.lineData.unit : undefined;
            if (
                row.line1 != oldLine1 &&
                (oldUnit != newUnit || row.valueType != ValueType.Text || oldType != ValueType.Text)
            ) {
                row.value = 0;
            }
        },

        hasCategory: function () {
            return (
                this.filterConfig.filter &&
                this.filterConfig.filter.category &&
                this.filterConfig.filter.category.length != 0
            );
        },

        canWizardFinish: function () {
            return (
                this.checkConditions() &&
                this.model.get('name').length > 0 &&
                !(
                    this.ui.sendToMailList &&
                    this.ui.sendToMailList.prop('checked') &&
                    this.model.get('send_list').length === 0
                )
            );
        },

        checkConditions: function () {
            if (!(this.model.get('conditions') || []).length) {
                return false;
            }

            var isValid = true;
            _.each(this.model.get('conditions'), function (x) {
                isValid = isValid && x.line1 && x.comparison;
            });
            return isValid;
        },

        canWizardChange: function (is, was) {
            // is there at least one constraint?
            return (
                (this.checkConditions() ||
                    !this.filterConfig.wizardCtx ||
                    is != this.filterConfig.wizardCtx.tabCount) &&
                this.base.canWizardChange(is, was)
            );
        },

        doWizardNext: function () {
            this.ui.categoryError.addClass('hidden');
            if (this.selected === this.filterTab) {
                // no category selected? -> stay on tab and warn user
                if (!this.hasCategory()) {
                    Decorator.flash($('button[data-id="df-categories"]'));
                    this.ui.categoryError.removeClass('hidden');
                    return;
                }
            }

            if (this.selected === this.errorTab) {
                this.updateSelectedErrors(this.ui.multiSelect.val() || []);
            }
            this.base.doWizardNext();
        },

        onRender: function () {
            Misc.initSelectPicker();
        },

        onShow: function () {
            this.base.onShow();
            Misc.initSelectPicker();
        },

        getAlarmObject: function () {
            return { filter: this.filterConfig.filter };
        },

        getAlarmCategories: function () {
            var alarmObj = this.getAlarmObject();
            return alarmObj && alarmObj.filter ? alarmObj.filter.category : undefined;
        },

        updateConditions: function () {
            // no category? no conditions
            if (!this.filterConfig.filter || !this.filterConfig.filter.category) this.model.set('conditions', []);

            var self = this;
            _.each(this.model.get('conditions'), function (row) {
                row.lineData = AppState.availableColumnDataByKey(row.line1key || row.line1, self.getAlarmCategories());
                row.valueType = self.getCondValueType(row);
                if (row.line2)
                    row.line2Data = AppState.availableColumnDataByKey(
                        row.line2key || row.line2,
                        self.getAlarmCategories()
                    );
                if (row.op && row.line2 && row.lineData && row.line2Data && row.lineData.unit != row.line2Data.unit)
                    row.line2 = '';
                row.enumItems =
                    row.lineData && row.lineData.format ? Misc.getEnumItems(row.lineData.format) : undefined;
                row.valueType = self.getCondValueType(row);

                if (row.valueType == ValueType.Status) {
                    row.statusValues = Alarm.getStatusValues(self.filterConfig.filter.category);
                }

                // comparison
                row.comparisonOpList = _.filter(Consts.Backend.Comparison, function (item) {
                    if (row.line1 == Consts.AlarmStatusField) return item.for_status;
                    if (row.valueType == ValueType.Enum) return item.for_list;

                    return !item.for_status;
                });
                // validate comparison
                if (
                    !Misc.countWhere(row.comparisonOpList, function (item) {
                        return item.k == row.comparison;
                    })
                ) {
                    if (row.comparisonOpList && row.comparisonOpList.length) row.comparison = row.comparisonOpList[0].k;
                }

                var valueUnit = AppState.getValueUnitByKey(
                    row.line1key || row.line1,
                    self.getAlarmCategories(),
                    row.value,
                    row.lineData ? row.lineData.unit : undefined
                );
                // get the name
                row.name = Alarm.getConditionText(row, false, self.getAlarmObject());

                switch (row.valueType) {
                    case ValueType.Text:
                        if (row.op == 'Z') {
                            row.valueConverted = row.value;
                        } else {
                            row.valueConverted = valueUnit && valueUnit.value ? valueUnit.value : row.value;
                        }

                        row.showRawValue = row.lineData && canShowRawValue(row.lineData.format);
                        break;
                    case ValueType.Status:
                        row.valueConverted = Alarm.decodeStatus(row.value);
                        break;
                }
            });
            this.updateWizardButtons();
        },

        getCondValueType: function (row) {
            if (row.line1 == Consts.AlarmStatusField) return ValueType.Status;
            if (!row.lineData) return ValueType.Text;
            if (row.enumItems && row.enumItems.length) return ValueType.Enum;

            return ValueType.Text;
        },

        getDeviceValues: function () {
            // no category: no fields
            if (!this.hasCategory()) return [];

            // determine available field values (based on selected categories) + device status field
            var fields = AppState.availableFields(this.filterConfig.filter.category, Consts.FieldGroup.Data);
            fields.push({ id: Consts.AlarmStatusField, name: Consts.AlarmStatusFieldText });

            // translate fields
            _.each(fields, function (e) {
                e.key = Alarm.getDeviceValueKey(e);
                e.name = I18N.DATAPOINT((e.categories || [''])[0], e.name);
            });

            // if a device is specified, use only those in the alarm and in the device
            var deviceConfig = this.options.model.get('deviceConfig');
            if (deviceConfig) {
                // generate a key map
                var keyMap = {};
                deviceConfig.toJSON().forEach(function (item) {
                    keyMap['' + item.type + '_' + item.nr + '$' + (item.unit || '') + '$' + item.name] = true;
                });

                // add line1key and line2key to the key map
                var conditions = this.model.get('conditions');
                conditions.forEach(function (item) {
                    if (item.line1key) {
                        keyMap[item.line1key] = true;
                    }
                    if (item.line2key) {
                        keyMap[item.line2key] = true;
                    }
                });

                fields = Misc.selectWhere(fields, function (item) {
                    return keyMap[item.key];
                });
            }

            // remove duplicite fields
            fields = _.uniq(fields, false, function (item) {
                return item.key;
            });

            return _.sortBy(fields, function (e) {
                return e.name;
            });
        },

        serializeData: function () {
            var data = this.base.serializeData();
            data.errors = this.errors;
            data.priorities = Consts.Priorities();
            data.calcOp = Consts.Backend.Operators;
            data.model = this.model.toJSON();
            data.deviceValues = this.getDeviceValues();
            data.mailboxes = this.options.mailboxes ? this.options.mailboxes.toJSON() : [];
            data.phone = AppState.user.get('phone');
            data.email = AppState.user.get('email');

            data.showMailBoxOption = data.mailboxes.length > 0 || AppState.hasCompanyUserPermission();

            data.isReceiverMeDisabled = this.options.model.id > 0 && this.options.model.get('send_list') !== undefined;
            data.isReceiverBoxDisabled = data.mailboxes.length == 0;

            this.updateConditions(data);
            return data;
        },

        wizardDone: function () {
            var self = this;
            this.model.set(
                'trigger_time',
                parseInt(this.model.get('trigger_time_value')) * parseInt(this.model.get('trigger_time_unit'))
            );

            // save data into the original model
            var model = this.options.model;
            _.each(
                ['name', 'trigger_time', 'priority', 'is_active', 'notify_corrected', 'send_email', 'send_sms'],
                function (key) {
                    model.set(key, self.model.get(key));
                }
            );

            model.set(
                'send_list',
                this.model.get('send_list').length > 0
                    ? _.map(this.model.get('send_list'), function (x) {
                          return { id: x };
                      })
                    : undefined
            );

            model.set('filter', this.filterIntf.filter);
            model.set(
                'conditions',
                _.map(this.model.get('conditions'), function (cond) {
                    return {
                        line1: cond.line1,
                        line2: cond.line2,
                        line1key: cond.line1key,
                        line2key: cond.line2key,
                        op: cond.op,
                        comparison: cond.comparison,
                        value: cond.value,
                    };
                })
            );

            var saveAlarm = function () {
                model.save(
                    {},
                    {
                        success: function () {
                            if (self.options.cb) {
                                self.options.cb(model);
                            }
                        },
                        error: function (m, r) {
                            self.errors = r.responseJSON || { error: 'general_error' };
                            self.render();
                        },
                    }
                );
            };

            var ownerDevice = model.get('ownerDevice');
            if (ownerDevice) {
                // create new filter restricted to owner device only
                var selection = new DeviceSelection({
                    filter: {
                        category: [ownerDevice.get('category')],
                        devices: [ownerDevice.id],
                    },
                });
                selection.saveChanges({});
                selection.done(function () {
                    model.set('filter', {
                        selection: selection.selectionID,
                        category: [ownerDevice.get('category')],
                    });
                    saveAlarm();
                });
            } else {
                saveAlarm();
            }
        },
    },
    'AlarmDialogView'
);

module.exports = AlarmDialogView;
